import React, { useContext } from "react";

// tooltip
import { Tooltip } from "react-tooltip";

// icons
import { AiOutlineFieldTime, AiOutlineRise } from "react-icons/ai";
import { MdOutlineAttachMoney, MdOutlineInventory2 } from "react-icons/md";
import { BsLinkedin, BsGlobe } from "react-icons/bs";

function CompanyCard({ supplier }) {
  const calcStarRating = (rating) => {
    const noOfStars = Math.floor((rating / 100) * 5);
    const stars = [];

    for (let i = 0; i < noOfStars; i++) {
      stars.push(
        <svg
          key={i} // Add a unique key for each star element
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      );
    }
    return stars;
  };
  return (
    <div className="h-44 rounded-lg w-1/2 p-4">
      <article className="rounded-lg border border-gray-600 bg-white p-6 shadow-md h-full flex flex-col justify-between">
        <div className="flex items-center justify-between">
          <div>
            <div class="flex gap-0.5 text-yellow-500">
              {calcStarRating(supplier.Rating)}
            </div>
            <p
              className="text-xl font-medium text-gray-900 cursor-pointer"
              data-tooltip-id="Name"
              //   onClick={() => {
              //     setcompKeyword(supplier.SupplierName);
              //   }}
            >
              {supplier.SupplierName.toUpperCase()}
            </p>
            <Tooltip
              id="Name"
              place="bottom"
              content="Supplier Name"
              className="rounded-lg"
            />
          </div>

          <span
            className="rounded-md bg-blue-100 p-3 text-blue-600"
            data-tooltip-id="Cost"
          >
            {supplier.Cost.toString().slice(0, 8)}
          </span>
          <Tooltip
            id="Cost"
            place="top"
            content="Cost function value out of 1000"
            className="rounded-lg"
          />
        </div>

        <div className="flex justify-between items-center text-md w-full">
          <div className="flex items-center gap-2">
            <div className="mt-1 flex gap-1 items-center">
              <AiOutlineFieldTime className="w-5 h-5" />

              <p className="flex gap-2 " data-tooltip-id="DeliveryTime">
                <span className="text-gray-500">
                  {" "}
                  {supplier.AverageDeliveryTime} hrs{" "}
                </span>
              </p>
            </div>
            <Tooltip
              id="DeliveryTime"
              place="bottom"
              content="Delivery Time in hours"
              className="rounded-lg"
            />
            <div className="mt-1 flex gap-1 items-center">
              <MdOutlineAttachMoney className="h-5 w-5" />

              <p className="flex gap-2 text-md" data-tooltip-id="AvgCost">
                <span className="text-gray-500">{supplier.AvgCost}</span>
              </p>
            </div>
            <Tooltip
              id="AvgCost"
              place="bottom"
              content="Average Cost per item"
              className="rounded-lg"
            />
            <div className="mt-1 flex gap-1 items-center">
              <AiOutlineRise className="h-5 w-5" />

              <p
                className="flex gap-2 text-md "
                data-tooltip-id="NumberofEscalations"
              >
                <span className="text-gray-500">
                  {supplier.NumberofEscalations}
                </span>
              </p>
            </div>
            <Tooltip
              id="NumberofEscalations"
              place="bottom"
              content="Number of Escalations"
              className="rounded-lg"
            />

            <div className="mt-1 flex gap-1 items-center">
              <MdOutlineInventory2 className="h-5 w-5" />

              <p className="flex gap-2 text-md" data-tooltip-id="Resources">
                <span className="text-gray-500">{supplier.Resources}</span>
              </p>
            </div>
            <Tooltip
              id="Resources"
              place="bottom"
              content="Resources"
              className="rounded-lg"
            />
          </div>

          <div className="flex items-center gap-2">
            <a
              href={"https://" + supplier.LinkedinUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-1 flex gap-1 items-center cursor-pointer"
              data-tooltip-id="LinkedIn"
            >
              <BsLinkedin className="h-5 w-5 text-blue-500" />
            </a>
            <Tooltip
              id="LinkedIn"
              place="bottom"
              content="LinkedIn Company Profile"
              className="rounded-lg"
            />
            <a
              href={"https://" + supplier.Domain}
              target="_blank"
              rel="noreferrer"
              className="mt-1 flex gap-1 items-center cursor-pointer float-right"
              data-tooltip-id="Website"
            >
              <BsGlobe className="h-5 w-5 text-orange-500" />
            </a>
            <Tooltip
              id="Website"
              place="bottom"
              content="Website of Company"
              className="rounded-lg"
            />
          </div>
        </div>
      </article>
    </div>
  );
}

export default CompanyCard;
